import { BarChart } from "@mui/x-charts/BarChart"
import { SiUnrealengine, SiUnity, SiCplusplus, SiGodotengine, SiPython, SiJavascript } from 'react-icons/si'
import {useTranslation} from "react-i18next";
import { useEffect, useState } from "react";
import cSharpLogo from '../images/icons/c-sharp-logo.png';
import sandboxLogo from '../images/icons/logo_s&box.svg'

export default function Tools(){
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const updateScreenSize = () => {
            const nextIsMobile = window.innerWidth <= 768;
            setIsMobile(prev => (prev === nextIsMobile ? prev : nextIsMobile));
        };

        updateScreenSize();
        window.addEventListener('resize', updateScreenSize);
        return () => window.removeEventListener('resize', updateScreenSize);
    }, []);

    const engines = [
        { name: 'Unreal Engine', icon: SiUnrealengine, value: 7 },
        { name: 'Unity', icon: SiUnity, value: 5 },
        { name: 'Godot', icon: SiGodotengine, value: 3 },
        { name: 'S&box', icon: sandboxLogo, value: 4}
    ];

    const programmingLanguages = [
        { name: 'C++', icon: SiCplusplus, value: 8 },
        { name: 'Unreal Blueprints', icon: SiUnrealengine, value: 7 },
        { name: 'C#', icon: cSharpLogo, value: 6 },
        { name: 'Python', icon: SiPython, value: 6 },
        { name: 'JavaScript', icon: SiJavascript, value: 5 },
        { name: 'UMG', icon: SiUnrealengine, value: 6 }
    ];

    const mobileChartHeight = 420;
    const mobileBarWidth = 20;

    const createChartSettings = (tools) => ({
        layout: isMobile ? 'vertical' : 'horizontal',
        colors: ['#b7e9f4'],
        borderRadius: 5,
        ...(isMobile
            ? {
                xAxis: [{
                    data: tools.map(t => t.name),
                    scaleType: 'band',
                }],
                yAxis: [{
                    min: 0,
                    max: 10,
                    tickNumber: 10,
                }],
            }
            : {
                yAxis: [{
                    data: tools.map(t => t.name),
                    scaleType: 'band',
                }],
                xAxis: [{
                    min: 0,
                    max: 10,
                    tickNumber: 10,
                }],
            }),
        series: [{
            data: tools.map(t => t.value),
        }],
        margin: isMobile
            ? { right: 6, left: 6 }
            : {  },
        height: isMobile ? mobileChartHeight : tools.length * 60 + 50,
        width: isMobile ? tools.length * mobileBarWidth + 70 : Math.floor(window.innerWidth * 0.8),
        sx: {
            '& .MuiChartsAxis-root': {
                '& .MuiChartsAxis-line, & .MuiChartsAxis-tick': {
                    stroke: '#b7e9f4 !important',
                },
                '& .MuiChartsAxis-tickLabel': {
                    fill: 'white !important',
                    fontSize: '0.72rem',
                },
            },
            '& .MuiBarElement-root': {
                stroke: '#b7e9f4',
                strokeWidth: 2,
            },
            ...(isMobile
                ? {
                    '& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel': {
                        transform: 'translateY(8px)',
                        fontSize: '0.62rem',
                    },
                    '& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel tspan': {
                        // fontSize: '0.62rem',
                        display: 'none',
                    },
                }
                : {
                    '& .MuiChartsAxis-left .MuiChartsAxis-tickLabel': {
                        display: 'none',
                    },
                    '& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel': {
                        display: 'none',
                    }
                }),
        }
    });

    const ChartSection = ({ title, tools }) => (
        <div className="chart-section">
            {isMobile ? (
                <>
                    <div className="chart-wrapper">
                        <BarChart {...createChartSettings(tools)} />
                    </div>

                    <div className="below-graph">
                        <div className="tools-icon-container">
                            {tools.map((tool, index) => {
                                const IconOrSrc = tool.icon;
                                return (
                                    <div key={index} title={tool.name} className={'tool-icon'}>
                                        {typeof IconOrSrc === "string" ? (
                                            <img src={IconOrSrc} alt={tool.name}/>
                                        ) : (
                                            <IconOrSrc />
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        <h2 className="graph-title">{title}</h2>
                    </div>
                </>
            ) : (
                <>
                    <h2 className="graph-title">{title}</h2>
                    <div className="chart-content">
                        <div className="tools-icon-container">
                            {tools.map((tool, index) => {
                                const IconOrSrc = tool.icon;
                                return (
                                    <div
                                        key={index}
                                        title={tool.name}
                                        className={'tool-icon'}
                                    >
                                        {typeof IconOrSrc === "string" ? (
                                            <img
                                                src={IconOrSrc}
                                                alt={tool.name}
                                            />
                                        ) : (
                                            <IconOrSrc />
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        <div className="chart-wrapper">
                            <BarChart {...createChartSettings(tools)} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );

    const { t } = useTranslation();

    return (
        <div>
            <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'row' : 'column',
                gap: '12px',
                width: '100%',
                alignItems: isMobile ? 'flex-end' : 'stretch',
                marginTop: 0
            }}>
                <ChartSection title={t('Engines')} tools={engines} />
                <ChartSection title={t('ProgrammingLanguages')} tools={programmingLanguages} />
            </div>
        </div>
    );
}